import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import { memo } from 'react';
import styled from 'styled-components';
import { ITextProps } from '@dealstack/frontend/shared/components/fundament/Text/Text.types';

interface Props {
	className?: string;
	number: number;
	title: string;
	subtitle?: string;
	titleVariant?: ITextProps['variant'];
	subtitleVariant?: ITextProps['variant'];
}

const PrimaryListItem = ({
	className,
	number,
	title,
	titleVariant = 'p-md',
	subtitleVariant = 'p-sm',
	subtitle,
}: Props) => {
	return (
		<div className={className}>
			<PrimaryBall number={number} />
			<TextWrapper>
				<TitleText variant={titleVariant} bold>
					{title}
				</TitleText>
				<SubtitleText colorFaded variant={subtitleVariant}>
					{subtitle}
				</SubtitleText>
			</TextWrapper>
		</div>
	);
};

export const PrimaryBall = styled(
	({ className, number }: { className?: string; number: number }) => {
		return (
			<div className={className}>
				<Text bold variant="button">
					{number}
				</Text>
			</div>
		);
	}
)`
	padding: 1rem;
	position: relative;
	width: fit-content;
	border-radius: 100%;
	background-color: ${({ theme }) => theme.v2.color.neutral[300]};
	${({ theme }) => theme.shadow.z4};

	${Text} {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
`;

const TitleText = styled(Text)``;
export const SubtitleText = styled(Text)``;
const TextWrapper = styled.div`
	display: flex;
	flex-direction: column;
`;

const Memoized = memo(PrimaryListItem);
const Styled = styled(Memoized)`
	display: flex;
	align-items: center;

	${PrimaryBall} {
		margin-right: 1rem;
	}
`;

export { Styled as PrimaryListItem };
